export default `
{
    subscription_migration_preview(raise_error: false) {
      available_migrate_options{
        accessory_count
        clothing_count
        next_billing_at
        title
        tote_count
        target_subscription_type_id
      }
      errors{
        error_code
        message
      }
      success
      tote_count
      next_billing_at
      tote_capacity
    }
  }
`

export const subscriptionMigration = `
mutation subscriptionMigration($input: SubscriptionMigrationInput!) {
    SubscriptionMigration(input: $input) {
      subscription {
        id
        totes_left
        totes_left_tips
        on_hold
        promo_code
        hold_date
        status
        billing_date
        display_interval
        billing_date_extending
        contract_display {
          menu_display
          order_display
          tote_display
        }
        next_tote_status {
          message
          code
          final_code
          can_create_tote
        }
        subscription_type {
          id
          interval
          display_name_v2
          internal_name
          clothing_count
          accessory_count
          occasion
          days_interval
          base_price
          original_price
          operation_plan {
            icon_v3_url
            banner_v3_url
            price_tips
            referral_banner
          }
          available_promo_codes {
            code
            description
            discount_amount
            expiration_date
            status
            title
            rules
            type
            condition_display
            subscription_type_ids
          } 
          operation_plan {
            icon_v3_url
            price_tips
            banner_v3_url
            referral_banner
          }
          is_accessory_slot_giveaway
          auto_renew_price_per_month
          preview {
            auto_renew_discount
            cash_price
            final_price
            name
            expiration_date_tips
            promo_code_price
          }
          free_service_type {
            id
            name
            clothing_count
            free_service_type_config {
              popup_content {
                img_url
              }
            }
          }
        }
      }
    }
}
`
